import React, { Fragment } from 'react'
import { Heading } from '@myxplor/ui'

const NoSummaries = () => (
  <Fragment>
    <Heading small>No Submissions found for the selected week</Heading>
    <p>Try selecting a different week</p>
  </Fragment>
)

export default NoSummaries



// WEBPACK FOOTER //
// ./src/session-summaries/views/empty.jsx